import { WithAccountId } from '@mews-commander/types';
import { PaymentCommonSection } from '../../../../common/PaymentCommonSection';
import { PaymentAmountSection } from '../../../../common/PaymentAmountSection';
import { PaymentRequestFormExpirationField } from './PaymentRequestFormExpirationField';
import { PaymentRequestFormMessageField } from './PaymentRequestFormMessageField';
import { PaymentRequestFormInternalNoteField } from './PaymentRequestFormInternalNoteField';
import { PaymentRequestFormEmailField } from './PaymentRequestFormEmailField';
import { PaymentRequestFormTitle } from './PaymentRequestFormTitle';

export const PreauthorizePaymentFormFields = ({ accountId }: WithAccountId) => (
    <>
        <PaymentRequestFormTitle />
        <PaymentCommonSection hideLinkPaymentToPlan hideInvoiceSelect />
        <PaymentAmountSection />
        <PaymentRequestFormExpirationField />
        <PaymentRequestFormEmailField accountId={accountId} />
        <PaymentRequestFormMessageField />
        <PaymentRequestFormInternalNoteField />
    </>
);
